import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";
import {
  ProposalHistoryDetails,
  ProposalHistoryItem,
  ProposalHistoryOtherExamComponent,
} from "@app/core/domain/proposal-history";
import { TranslatePipe } from "@ngx-translate/core";
import { AddCourseListHeaderComponent } from "@shared/components/add-course-list-header/add-course-list-header.component";
import { HistoryCourseItemComponent } from "../history-course-item/history-course-item.component";

@Component({
  selector: "pa-history-courses",
  templateUrl: "./history-courses.component.html",
  styleUrls: ["./history-courses.component.scss"],
  standalone: true,
  imports: [AddCourseListHeaderComponent, HistoryCourseItemComponent, NgClass, TranslatePipe],
})
export class HistoryCoursesComponent {
  @Input() historyItem!: ProposalHistoryItem;
  @Input() historyDetails!: ProposalHistoryDetails;

  getExamComponentName(examComponent: ProposalHistoryOtherExamComponent): string {
    return examComponent.specialisationName
      ? `${examComponent.name} (${examComponent.specialisationName})`
      : examComponent.name;
  }
}
